const Development = {
  dev: 'dev',
  development: 'development',
}

const Production = {
  prod: 'prod',
  production: 'production',
}

module.exports = {
  Production,
  Development,
}
